import type { OverviewPeriod, OverviewQuery } from "./overviewTypes";

export function readOverviewQuery(search: string): OverviewQuery {
  const params = new URLSearchParams(search);
  const period = params.get("period") || "programme_year";
  if (!["programme_year", "this_term", "last_term"].includes(period)) throw new Error("Choose an available reporting period.");
  return { period: period as OverviewPeriod, department: params.get("department") || "all", ...(params.get("initiative") ? { initiativeId: params.get("initiative") as string } : {}) };
}

export function writeOverviewQuery(search: string, query: OverviewQuery): string {
  const params = new URLSearchParams(search);
  params.set("period", query.period);
  params.set("department", query.department);
  if (query.initiativeId) params.set("initiative", query.initiativeId);
  else params.delete("initiative");
  return `?${params.toString()}`;
}
